const { get } = require('lodash');

module.exports = function(value, meta) {
  if (!value || !value.records) return '';

  let items = [];
  if ('availableCatalogItems' in meta) {
    items = meta.availableCatalogItems;
  } else if (meta.references && 'availableCatalogItems' in meta.references) {
    items = meta.references.availableCatalogItems;
  }
  return value.records
    .map(({ id, quantity }) => {
      const name = get(items.find(c => c.id === id), 'value', 'No Value');
      return `${name} (${quantity})`;
    })
    .join(', ');
};
